import React, { useMemo } from 'react';
import { usePublish } from '@atlaskit/rovo-triggers';
import SuggestedEditIcon from '@atlaskit/icon-lab/core/suggested-edit';
import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';
import type { AIActionStatus } from '@atlassian/ai-smart-button-api';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { usePathParam } from '@atlassian/react-resource-router';

const BOARD_VIEW_ROUTE_NAMES = [
	'software-boards',
	'rapidboard-board',
	'rapidboard-user-board',
	'servicedesk-boards',
	'classic-business-board',
];

const useCurrentRouteName = createRouterSelector((state) => state.route.name);
// this is a shortcut to show the nudge in board view for team EU demo
// TODO: clean up when team EU demo is done
export const useRovoButtonNudges = () => {
	const routeName = useCurrentRouteName();
	const publish = usePublish('ai-mate');
	const [projectKey] = usePathParam('projectKey');

	const nudges = useMemo(() => {
		if (
			BOARD_VIEW_ROUTE_NAMES.includes(routeName) &&
			projectKey === 'WPI' &&
			fg('jira_issue_view_rovo_button_nudge')
		) {
			const cta = 'Update work items';
			const nudgeStatus: AIActionStatus = 'beta';
			return [
				{
					id: `${routeName}-rovo-nudge`,
					title: cta,
					description: cta,
					icon: <SuggestedEditIcon label={cta} size="medium" />,
					nudgeIcon: () => <SuggestedEditIcon label={cta} size="medium" />,
					onClick: () => {
						publish({
							type: 'chat-new',
							product: 'jira',
							source: `${routeName}-rovo-nudge`,
							data: {
								name: cta,
								dialogues: [],
								prompt: `${expVal('loom_link_team_eu_demo', 'value', 'Update work items based on the update from this meeting https://stage.loom.com/share/07077aaf627949d59d35ae37c35c8053')}`,
								minionAlias: 'project-manager',
							},
						});
					},
					sourceId: 'jira-ai-rovo-button',
					status: nudgeStatus,
				},
			];
		}
		return [];
	}, [routeName, publish, projectKey]);
	return nudges;
};
